import React from 'react';
import PropTypes from 'prop-types';
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonLabel,
  IonList,
  IonItem,
  IonBackButton,
  IonIcon,
  IonModal,
  IonButton,
  IonInput,
  IonItemDivider,
  IonSpinner,
  IonToast,
  IonText,
  IonProgressBar,
  IonBadge
} from '@ionic/react';
import { connect } from 'react-redux'
import { close, send, mail, cashOutline } from 'ionicons/icons';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CurrencyFormat from 'react-currency-format';

import './Tutor.css';
import TutorActions from '../../../actions/pays';
import ErrorAlert from '../../../components/ErrorAlert';

interface IProps {
  data: any;
  getChild: any;
  changeFields: any;
  sendMessages: any;
  errorForm: any;
}

interface IState {
  showModal: boolean;
  data: any;
  match: any;
  balance: any;
  pending: any;
  paidout: any;
}

class Pay extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props)
    this.state = {data: props.data, showModal:false, match: props.match, balance: 0, pending: 0, paidout: 0}
  }

  statusModal(open: boolean, tutor: any = null){
    if (open) {
      let fields = this.state.data.fields;
      fields.tutor = tutor;
      fields.correoTutor = tutor.correousuario;
      fields.message = "";
      this.props.changeFields(fields);
      this.props.errorForm({errors:{}});
    }

    this.setState({
      showModal: open
    });
  }

  componentDidMount(){
    if(this.state.data.eva.length === 0){
      this.props.getChild({id: this.state.match.params.child}, "get_child");
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: any){
    this.setState({
      data: nextProps.data,
    });
    var aux1 = 0;
    var aux2 = 0;
    nextProps.data.pays.map((val:any, key:any) => {
      if (val.idestado === "2") {
        console.log("2");
        aux2 = aux2 + parseInt(val.monto);
      }
      aux1 = aux1 + parseInt(val.monto);
    });
    this.setState({ balance: aux1-aux2, pending: aux1, paidout: aux2 })
  }

  handleChange(event: any) {
    let fields = this.state.data.fields;
    fields[event.target.name] = event.target.value;
    this.props.changeFields(fields)
  }

  handleChangeEditor(content: any) {
    let fields = this.state.data.fields;
    fields.message = content;
    this.props.changeFields(fields)
  }

  sendMessage(){
    const fields = this.state.data.fields;
    fields.para = [];
    fields.para.push(this.state.data.fields.tutor);
    fields.sms = {contenido: this.state.data.fields.message, titulo: this.state.data.fields.subject};
    this.props.sendMessages(fields, "sent_messages_tutor");
  }

  render() {
    const { doc, user, fields, simpleToast, toastMessage, formErrors, pays, error, error401, loading } = this.state.data;
    const { balance, pending, paidout } = this.state;
    return (
      <IonPage>
        <ErrorAlert/>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonBackButton defaultHref="/progress" />
            </IonButtons>
            <IonTitle>{ !error && !error401 && user.alumno ? user.alumno : error || error401 ? "Error en la petición":"Cargando..." }</IonTitle>
          </IonToolbar>
          <IonToolbar className="toolbarTint">
            <IonTitle style={ !error && !error401 && user.alumno ? {display: "block"}: {display: "none"}} className="ion-text-center">IB: {user.grado} {user.seccion} - {user.turno}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>

        <IonModal isOpen={this.state.showModal} >
          <IonHeader>
            <IonToolbar color="primary">
              <IonButtons slot="end">
                <IonButton onClick={this.sendMessage.bind(this)} disabled={loading}>
                  <IonIcon icon={send} />
                </IonButton>
                <IonButton onClick={this.statusModal.bind(this, false)} disabled={loading}>
                  <IonIcon icon={close}/>
                </IonButton>
              </IonButtons>
              <IonTitle>Nueva notificación</IonTitle>
            </IonToolbar>
          </IonHeader>

          <IonToast
            isOpen={simpleToast}
            buttons={[
              {
                text: 'Ok',
                role: 'cancel'
              }
            ]}
            message={`${toastMessage}`}
            duration={3000}
          />

          <IonContent >
            <IonProgressBar style={ loading ? {display: 'block'} : {display: 'none'}} type="indeterminate"></IonProgressBar>
            <IonList id="inside-mce">
              <IonItem>
                <IonLabel>Para:</IonLabel>
                <IonInput placeholder="para"  value={fields.correoTutor} disabled></IonInput>
              </IonItem>
              <IonItem>
                <IonInput name="subject" placeholder="Asunto"  value={fields.subject || "" } onIonChange={this.handleChange.bind(this)}></IonInput>
              </IonItem>
              {formErrors.errors && formErrors.errors.subject && (
                <IonText color="danger" className="ion-padding-start">
                  <small>{formErrors.errors.subject}</small>
                </IonText>
              )}
              <IonItemDivider>Redactar mensaje</IonItemDivider>
              <ReactQuill theme="snow" value={fields.message || ""} onChange={this.handleChangeEditor.bind(this)}/>
              {formErrors.errors && formErrors.errors.message && (
                <IonText color="danger" className="ion-padding-start">
                  <small>{formErrors.errors.message}</small>
                </IonText>
              )}
            </IonList>
          </IonContent>
        </IonModal>
        <div style={ loading ? {display: "block", paddingTop: '10%'} : {display: "none"}} className="ion-text-center"><IonSpinner name="circles" color="primary"/></div>
        <h1 style={error || error401 && !loading ? {display: "block"} : {display: "none"}} className="ion-text-center">Error en el sistema, consulte con el administador de la aplicación.</h1>


          <IonItem style={!error && !error401 && !loading && pays.length > 0 ? {display: "block"} : {display: "none"} }>
            <h1>Resumen de pagos</h1>
          </IonItem>
          <IonItem style={!error && !error401 && !loading && pays.length > 0 ? {display: "block"} : {display: "none"} }> 
            <IonLabel>
              <h2>Total colegiatura:</h2>
              <h2>Pagado:</h2>
              <h2><strong>Saldo:</strong></h2>
            </IonLabel>
            <IonLabel slot="end" class="ion-text-end">
              <h2><strong><IonIcon icon={cashOutline} color="primary"/><CurrencyFormat value={pending} displayType={'text'} thousandSeparator={true} prefix={''} fixedDecimalScale={true} decimalSeparator="." decimalScale={2}/></strong></h2>
              <h2><strong><IonIcon icon={cashOutline} color="primary"/><CurrencyFormat value={paidout} displayType={'text'} thousandSeparator={true} prefix={''} fixedDecimalScale={true} decimalSeparator="." decimalScale={2}/></strong></h2>
              <h2><strong><IonIcon icon={cashOutline} color="primary"/><CurrencyFormat value={balance} displayType={'text'} thousandSeparator={true} prefix={''} fixedDecimalScale={true} decimalSeparator="." decimalScale={2}/></strong></h2>
            </IonLabel>
          </IonItem>





        <IonList style={!error && !error401 && !loading ? {display: "block"} : {display: "none"} }>
          <h1 style={pays.length === 0 && !loading ? {display: "block"} : {display: "none"}} className="ion-text-center">No hay registros</h1>
          {pays.map((val:any, key:any) => {
            return (
              <IonItem key={key}> 
                <IonLabel>
                  <h2>{val.concepto}</h2>
                  <p>{val.fecha_vencimiento}</p>
                </IonLabel>
                <IonLabel slot="end" class="ion-text-end">
                  <h2><strong><IonIcon icon={cashOutline} color="primary"/> <CurrencyFormat value={val.monto} displayType={'text'} thousandSeparator={true} prefix={''} fixedDecimalScale={true} decimalSeparator="." decimalScale={2}/></strong></h2>
                  <IonBadge color={ val.idestado === "2" ? "primary" : "danger" }>{val.estado}</IonBadge>
                </IonLabel>
              </IonItem>
            );
          })}

        </IonList>

        </IonContent>
      </IonPage>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    data: state.data,
    getChild: PropTypes.func.isRequired,
    changeFields: PropTypes.func.isRequired,
    sendMessages: PropTypes.func.isRequired,
    errorForm: PropTypes.func.isRequired
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getChild: (fields: any, typeOptions: string) => dispatch(TutorActions.getChild(fields, typeOptions)),
    changeFields: (fields: any) => dispatch(TutorActions.changeFields(fields)),
    sendMessages: (fields: any, typeOptions: string) => dispatch(TutorActions.sendMessages(fields, typeOptions)),
    errorForm: (errors: any) => dispatch(TutorActions.errorForm(errors)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Pay);
